import * as Actions from '../../actions/userAttendance/type';

const initialState = {
  getMechanicJobsLoading: false,
  getMechanicJobs: [],
  getMechanicJobsError: '',

  mechanicAttendanceListLoading: false,
  mechanicAttendanceList: '',
  mechanicAttendanceListErrors: '',

  clockInLoading: false,
  clockInData: '',
  clockInError: '',

  clockOutLoading: false,
  clockOutData: '',
  clockOutError: '',

  breakStartLoading: false,
  breakStartData: '',
  breakStartError: '',

  breakEndLoading: false,
  breakEndData: '',
  breakEndError: '',
};
const mechanicReducer = (state = initialState, action) => {
  switch (action.type) {
    // get mechanic job cards

    case Actions.GET_MECHANIC_JOBCARDS_REQUEST:
      return {
        ...state,
        getMechanicJobsLoading: true,
      };
    case Actions.GET_MECHANIC_JOBCARDS_SUCCESS:
      return {
        ...state,
        getMechanicJobsLoading: false,
        getMechanicJobs: action.payload?.jobcards || [],
      };
    case Actions.GET_MECHANIC_JOBCARDS_FAIL:
      return {
        ...state,
        getMechanicJobsLoading: false,
        getMechanicJobsError: action?.payload || '',
      };

    // get mechanic attendance list

    case Actions.GET_MECHANIC_ATTENDANCE_LIST_REQUEST:
      return {
        ...state,
        mechanicAttendanceListLoading: true,
      };
    case Actions.GET_MECHANIC_ATTENDANCE_LIST_SUCCESS:
      return {
        ...state,
        mechanicAttendanceList: action.payload || '',
        mechanicAttendanceListLoading: false,
      };
    case Actions.GET_MECHANIC_ATTENDANCE_LIST_FAIL:
      return {
        ...state,
        mechanicAttendanceListLoading: false,
        mechanicAttendanceListErrors: action?.payload || '',
      };

    // mechanic clock in

    case Actions.CLOCK_IN_REQUEST:
      return {
        ...state,
        clockInLoading: true,
      };
    case Actions.CLOCK_IN_SUCCESS:
      return {
        ...state,
        clockInData: action?.payload || '',
        clockInLoading: false,
      };
    case Actions.CLOCK_IN_FAIL:
      return {
        ...state,
        clockInLoading: false,
        clockInError: action?.payload || '',
      };
    case Actions.CLEAR_CLOCK_IN_STATE:
      return {
        ...state,
        clockInData: '',
      };

    // mechanic clock out

    case Actions.CLOCK_OUT_REQUEST:
      return {
        ...state,
        clockOutLoading: true,
      };
    case Actions.CLOCK_OUT_SUCCESS:
      return {
        ...state,
        clockOutData: action?.payload || '',
        clockOutLoading: false,
      };
    case Actions.CLOCK_OUT_FAIL:
      return {
        ...state,
        clockOutLoading: false,
        clockOutError: action?.payload || '',
      };
    case Actions.CLEAR_CLOCK_OUT_STATE:
      return {
        ...state,
        clockOutData: '',
      };

    // mechanic break start

    case Actions.BREAK_START_REQUEST:
      return {
        ...state,
        breakStartLoading: true,
      };
    case Actions.BREAK_START_SUCCESS:
      return {
        ...state,
        breakStartData: action?.payload || '',
        breakStartLoading: false,
      };
    case Actions.BREAK_START_FAIL:
      return {
        ...state,
        breakStartLoading: false,
        breakStartError: action?.payload || '',
      };
    case Actions.CLEAR_BREAK_START_STATE:
      return {
        ...state,
        breakStartData: '',
      };

    // mechanic break end

    case Actions.BREAK_END_REQUEST:
      return {
        ...state,
        breakEndLoading: true,
      };
    case Actions.BREAK_END_SUCCESS:
      return {
        ...state,
        breakEndData: action?.payload || '',
        breakEndLoading: false,
      };
    case Actions.BREAK_END_FAIL:
      return {
        ...state,
        breakEndLoading: false,
        breakEndError: action?.payload || '',
      };
    case Actions.CLEAR_BREAK_END_STATE:
      return {
        ...state,
        breakEndData: '',
      };

    default:
      return state;
  }
};

export { mechanicReducer };
